<template>
  <div class="study">
    <div class="study__main">
      <transition>
        <div v-if="currentPageName === 'MenuStudy1'" key="MenuStudy1">
          <MenuStudy1 v-on:on-return="changePage('MenuMain')" v-on:goto-menu-study2="changePage('MenuStudy2')" />
        </div>
        <div v-else-if="currentPageName === 'MenuStudy2'" key="MenuStudy2">
          <MenuStudy2 v-on:on-return="changePage('MenuStudy1')" v-on:goto-pre-study="gotoPreStudy" />
        </div>
        <div v-else-if="currentPageName === 'PreStudy'" key="PreStudy">
          <PreStudy v-bind:study-id="testId" v-on:goto-test-study="gotoTestStudy" />
        </div>
        <div v-else-if="currentPageName === 'MenuExam1'" key="MenuExam1">
          <MenuExam1 v-on:on-return="changePage('MenuMain')" v-on:goto-menu-exam2="changePage('MenuExam2')"/>
        </div>
        <div v-else-if="currentPageName === 'MenuExam2'" key="MenuExam2">
          <MenuExam2 v-on:on-return="changePage('MenuExam1')" v-on:goto-test-exam="gotoTestExam" />
        </div>
        <div v-else-if="currentPageName === 'TestContent'" key="TestContent">
          <TestContent v-bind:test-type="testType" v-bind:test-id="testId" v-on:goto-self-menu="gotoSelfMenu"  v-on:goto-factory="closePage" />
        </div>
        <div v-else>
          <MenuMain v-on:on-return="closePage" v-on:goto-menu-study1="changePage('MenuStudy1')"  v-on:goto-menu-exam1="changePage('MenuExam1')" />
        </div>
      </transition>
    </div>
  </div>
</template>

<style lang="scss" scoped>

  .study {
    width: 100%;
    height: 100%;
    background-color: rgba(0,0,0,0.7);
  }

  .study__main {
    width: 100%;
    height: 100%;
  }

  .v-enter-active, .v-leave-active {
    transition: opacity 0.5s;
  }

  .v-enter, .v-leave-to {
    opacity: 0;
  }
</style>

<script>
  import MenuMain from '@/components/Study/MenuMain';
  import MenuStudy1 from '@/components/Study/MenuStudy1';
  import MenuStudy2 from '@/components/Study/MenuStudy2';
  import MenuExam1 from '@/components/Study/MenuExam1';
  import MenuExam2 from '@/components/Study/MenuExam2';
  import PreStudy from '@/components/Study/PreStudy';
  import TestContent from '@/components/Study/TestContent';

  export default {
    name: 'PageStudy',

    components: {
      MenuMain,
      MenuStudy1,
      MenuStudy2,
      MenuExam1,
      MenuExam2,
      PreStudy,
      TestContent
    },

    data() {
      return {
        currentPageName: 'MenuMain',
        //currentPageName: 'TestContent',
        testType: 'study',  // study / exam
        testId: 1
      }
    },

    created() {

    },

    computed: {

    },

    methods: {

      closePage() {
        this.$emit('close-page');
      },

      changePage(pagename) {
        this.currentPageName = pagename;
      },

      gotoPreStudy(study_id) {
        
        this.testId = study_id;
        this.changePage('PreStudy');
      },

      gotoTestStudy(study_id) {
        
        this.testId = study_id;
        this.testType = 'study';
        this.changePage('TestContent');
      },

      gotoTestExam(exam_id) {
        
        this.testId = exam_id;
        this.testType = 'exam';
        this.changePage('TestContent');
      },

      gotoSelfMenu(test_type) {

        if (test_type == 'study') {
          this.testType = 'study';
          this.changePage('MenuStudy1');

        } else if (test_type == 'exam') {
          this.testType = 'exam';
          this.changePage('MenuExam1');

        } else {
          this.changePage('MenuMain');
        }        
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/PageStudy.vue